import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
// import "../SignIn.css";
import logo from "../imgs/logo.png";
import { LockClosedIcon } from "@heroicons/react/20/solid";
import { useAuth } from "./useAuth";
import axios from "axios";
import url from "./url";
function SignIn() {
  const [spin, setSpin] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  var { login } = useAuth();

  const handleSignIn = (event) => {
    setErrorMessage("");
    event.preventDefault(); // prevent page reload

    setSpin(true);

    axios
      .post(url + "sdk/auth/login", {
        email,
        password,
      })
      .then((res) => {
        console.log("res");
        console.log(res);
        localStorage.setItem("token", res.data.result.accessToken);
        localStorage.setItem("user_id", res.data.result.id);
        localStorage.setItem("status", "true");
        navigate("/scan");
        // alert(res.data.result.id);
      })
      .catch((e) => {
        setErrorMessage("Wrong username or password");
      })
      .then((r) => {
        // setErrorMessage("Wrong username or password");
        setSpin(false);
      });
    // var { uname, pass } = document.forms[0];
    // console.log(uname.value,pass.value);
    // login(email, password).then((res) => {
    //   console.log("response from login : ", res);
    //   setErrorMessage(res.message);
    //   if (res.status) {
    //     console.log("Response : ", res);
    //     sessionStorage.setItem("licence", res.licencekey);
    //     sessionStorage.setItem("token", res.accessToken);
    //     // navigate("/scan");
    //   }
    // });
  };
  return (
    <>
      <div className="flex min-h-full items-center justify-center py-12 md:px-4 sm:px-0 lg:px-8 w-full">
        <div className="w-full max-w-md space-y-8">
          <div>
            <img className="mx-auto w-32 h-28" src={logo} alt="Docsun" />
            {/* <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">
              Docsun AI SDK
            </h2> */}
            <p className="mt-2 text-center text-lg text-gray-600">
              Non-Contact Vital Health Solutions For All
            </p>
          </div>
          <form className="mt-8 space-y-6" action="#" onSubmit={handleSignIn}>
            <input type="hidden" name="remember" defaultValue="true" />
            <div className="-space-y-px rounded-md shadow-sm">
              <div>
                <label htmlFor="email-address" className="sr-only">
                  Email address
                </label>
                <input
                  id="email-address"
                  name="uname"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Email address"
                />
              </div>
              <div>
                <label htmlFor="password" className="sr-only">
                  Password
                </label>
                <input
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  id="password"
                  name="pass"
                  type="password"
                  autoComplete="current-password"
                  required
                  className="my-2 relative block w-full appearance-none  rounded-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                  placeholder="Password"
                />
              </div>
            </div>

            <div className="flex items-center justify-between">
              {/* <div className="flex items-center"> */}
              {/* <input
                  id="remember-me"
                  name="remember-me"
                  type="checkbox"
                  className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                />
                <label
                  htmlFor="remember-me"
                  className="ml-2 block text-sm text-gray-900"
                >
                  Remember me
                </label> */}
              {/* </div> */}

              <div className="text-sm">
                {/* <a
                  href="#"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Forgot your password?
                </a> */}
              </div>
              <div className="text-sm">
                <Link
                  to="/signup"
                  className="font-medium text-indigo-600 hover:text-indigo-500"
                >
                  Create an Account
                </Link>
              </div>
            </div>

            <div className="error__value text-red-500">{errorMessage} </div>
            <div className="error__value text-red-500">
              {spin ? (
                <>
                  <div role="status">
                    <svg
                      aria-hidden="true"
                      class="w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                      viewBox="0 0 100 101"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                        fill="currentColor"
                      />
                      <path
                        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                        fill="currentFill"
                      />
                    </svg>
                    <span class="sr-only">Loading...</span>
                  </div>
                </>
              ) : null}{" "}
            </div>

            <div>
              <button
                type="submit"
                className="group relative flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                  <LockClosedIcon
                    className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400"
                    aria-hidden="true"
                  />
                </span>
                Login
              </button>
            </div>
          </form>
        </div>
      </div>
      {/* <div className="container">
        <div className="forms-container">
          <div className="signin-signup">
            <form action="#" className="sign-in-form" onSubmit={handleSignIn}>
              <h2 className="title">Sign in</h2>
              <div className="input-field">
                <i className="fas fa-user"></i>
                <input type="text" placeholder="Username" name="uname" />
              </div>
              <div className="input-field">
                <i className="fas fa-lock"></i>
                <input type="password" name="pass1" placeholder="Password" />
              </div>
              <div className="error__value">{errorMessage}</div>
              <input type="submit" value="Login1" className="btn solid" />
            </form>
          </div>
        </div>
        <div className="panels-container">
          <div className="panel left-panel">
            <div className="content">
              <h3>Docsun AI SDK</h3>
              <p>Non-Contact Vital Health Solutions For All</p>
            </div>
            <img src={logo} alt="Docsun" className="image" />
          </div>
        </div>
      </div> */}
    </>
  );
}

export default SignIn;
